import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams, useLocation, useNavigate } from 'react-router-dom';
import Home from './pages/Home';
import CreateEvent from './pages/CreateEvent';
import SetGender from './pages/SetGender';
import Reveal from './pages/Reveal';
import "./App.css";
import Header from './components/Header';
import Footer from './components/Footer';
import SeoHelmet from './components/SeoHelmet';
import './i18n';
import { useTranslation } from 'react-i18next';

const SUPPORTED_LANGS = [
  'en', 'pl', 'de', 'es', 'fr', 'it', 'pt', 'ru', 'uk'
];

function LanguageSetter() {
  const { i18n } = useTranslation();
  const location = useLocation();
  useEffect(() => {
    const lang = location.pathname.split('/')[1];
    if (SUPPORTED_LANGS.includes(lang)) {
      i18n.changeLanguage(lang);
    } else {
      i18n.changeLanguage('en');
    }
  }, [location, i18n]);
  return null;
}

function LanguageGuard() {
  const { lang } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    if (!SUPPORTED_LANGS.includes(lang)) {
      navigate(`/en/`, { replace: true });
    }
  }, [lang, navigate]);
  return null;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/en/" replace />} />
      <Route path="/:lang/" element={<><LanguageGuard /><Home /></>} />
      <Route path="/:lang/create" element={<><LanguageGuard /><CreateEvent /></>} />
      <Route path="/:lang/set/:id" element={<><LanguageGuard /><SetGender /></>} />
      <Route path="/:lang/c/:id" element={<><LanguageGuard /><Reveal /></>} />
      <Route path="*" element={<Navigate to="/en/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <LanguageSetter />
      <SeoHelmet
        title="revealoo.com – Najbardziej kolorowy licznik gender reveal!"
        description="Stwórz darmowe wydarzenie z odliczaniem do ujawnienia płci dziecka. Udostępnij link bliskim i baw się magią reveal party!"
      />
      <Header />
      <AppRoutes />
      <Footer />
    </Router>
  );
}

export default App;
